import React from 'react';
import PropTypes from 'prop-types';
import { LiveFeedWrapper, LiveFeedList } from './LiveFeed.style';
import InningBlock from './InningBlock';

const LiveFeed = ({
    playsByInning = [],
    teams,
    reverseChron = true,
    isLoading = false,
    showAllPitches = false,
    showAnimations = false,
    openAtBatOverlay,
    showBasesText
}) => {
    const playsProps = {
        teams,
        offset: true,
        reverseChron,
        showAllPitches,
        showAnimations,
        openAtBatOverlay,
        showBasesText
    };

    const orderedPlaysByInning = reverseChron
        ? [...playsByInning].reverse()
        : playsByInning;

    return (
        <LiveFeedWrapper>
            <LiveFeedList
                reverse={reverseChron}
                $hasList={orderedPlaysByInning.length > 0}
            >
                {orderedPlaysByInning.map((playsObj, i) => {
                    const inning = reverseChron
                        ? orderedPlaysByInning.length - i
                        : i + 1;

                    return (
                        <InningBlock
                            key={`inning-${inning}`}
                            playsObj={playsObj}
                            inning={inning}
                            reverseChron={reverseChron}
                            playsProps={playsProps}
                            isLoading={isLoading}
                        />
                    );
                })}
            </LiveFeedList>
        </LiveFeedWrapper>
    );
};

LiveFeed.propTypes = {
    openAtBatOverlay: PropTypes.func,
    playsByInning: PropTypes.arrayOf(PropTypes.object),
    teams: PropTypes.object,
    reverseChron: PropTypes.bool,
    isLoading: PropTypes.bool,
    showAllPitches: PropTypes.bool,
    showAnimations: PropTypes.bool,
    showBasesText: PropTypes.bool
};

export default LiveFeed;
